export default "__VITE_ASSET__DahQV$Xe__"